import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
// import "./Header.css";

const Header = () => {
  return (
    <header className="site-header">
      <div className="top-logo-area">
        <a href="/" className="logo-link">
          <img
            src="img/logo-top.png"
            className="logoMenu"
            alt="Event Merchandise Services"
          />
        </a>
      </div>

      <Navbar collapseOnSelect expand="lg" className="custom-navbar">
        <Container>

          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="navbar-toggler-custom"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="responsive-navbar-nav">

            <Nav className="mx-auto custom-nav">

              <Nav.Link href="#containerPartner">
                Partner
              </Nav.Link>

              <Nav.Link href="#equipmentHire">
                Services
              </Nav.Link>

              <Nav.Link href="#merchServices">
                Events
              </Nav.Link>

              <Nav.Link href="#contact">
                Contact
              </Nav.Link>

              <Nav.Link
                href="https://sportsfan.co.nz"
                target="_blank"
                rel="noopener noreferrer"
                className="shop-btn"
              >
                🛒 Shop
              </Nav.Link>

            </Nav>

          </Navbar.Collapse>

        </Container>
      </Navbar>
    </header>
  );
};

export default Header;